import { Injectable } from "@angular/core";
import { ServicioGeneral } from "./servicio-general.service";
import { BehaviorSubject, Observable, filter, pipe } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class NotificationReadService {
  constructor(private general: ServicioGeneral) {}

  private alertMapSubject: BehaviorSubject<Map<string, string>> =
    new BehaviorSubject<Map<string, string>>(new Map());

  getAlertMap(): Observable<Map<string, string>> {
    this.updateAlertMap()
    return this.alertMapSubject.asObservable();
  }
  updateAlertMap(): void {
    this.general.getNotificaSinLeer().subscribe((response) => {
      this.alertMapSubject.next(
        new Map([
          ["notificaciones", response.notificaciones], 
          ["comunicaciones", response.comunicaciones],
          ["autorizaciones", response.autorizaciones],
          ["totales", response.totales],
        ])
      );
    });
  }
}
